export default __webpack_public_path__ + "static/media/hh1.19e99c3c.png";